/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BCMOsisRuleFormConfiguration,
    BCMOsisRuleFormConfigurationFromJSON,
    BCMOsisRuleFormConfigurationToJSON,
    BCMOsisRuleFormData,
    BCMOsisRuleFormDataFromJSON,
    BCMOsisRuleFormDataToJSON,
    BCMOsisRuleFormValidationData,
    BCMOsisRuleFormValidationDataFromJSON,
    BCMOsisRuleFormValidationDataToJSON,
} from '../models';

export interface ApiBookingCreateManagerOsisBCMOsisRuleFormCreatePostRequest {
    bCMOsisRuleFormData?: BCMOsisRuleFormData;
}

export interface ApiBookingCreateManagerOsisBCMOsisRuleFormDataGetRequest {
    id?: string;
}

export interface ApiBookingCreateManagerOsisBCMOsisRuleFormUpdatePostRequest {
    bCMOsisRuleFormData?: BCMOsisRuleFormData;
}

export interface ApiBookingCreateManagerOsisBCMOsisRuleFormValidatePostRequest {
    bCMOsisRuleFormData?: BCMOsisRuleFormData;
}

/**
 * no description
 */
export class BCMOsisRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<BCMOsisRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMOsisRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormConfigurationGet(): Promise<BCMOsisRuleFormConfiguration> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormCreatePostRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMOsisRuleFormDataToJSON(requestParameters.bCMOsisRuleFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormCreatePost(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormCreatePostRequest): Promise<string> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormDataGetRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormDataGetRequest): Promise<runtime.ApiResponse<BCMOsisRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMOsisRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormDataGet(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormDataGetRequest): Promise<BCMOsisRuleFormData> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormUpdatePostRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMOsisRuleFormDataToJSON(requestParameters.bCMOsisRuleFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormUpdatePost(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormUpdatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerOsisBCMOsisRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormValidatePostRaw(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormValidatePostRequest): Promise<runtime.ApiResponse<BCMOsisRuleFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/Osis/BCMOsisRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMOsisRuleFormDataToJSON(requestParameters.bCMOsisRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMOsisRuleFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisBCMOsisRuleFormValidatePost(requestParameters: ApiBookingCreateManagerOsisBCMOsisRuleFormValidatePostRequest): Promise<BCMOsisRuleFormValidationData> {
        const response = await this.apiBookingCreateManagerOsisBCMOsisRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
